import React, { useContext, useEffect, useState } from 'react';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';
import { Form } from 'react-bootstrap';
import { FaTimes } from "react-icons/fa";
import { TbTrash } from "react-icons/tb";
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import LoadingScreen from '../LoadingScreen';

export default function ModalMatrizTime({ setModalAvaliar }) {
    const { RetornaSistemaCapacidade, CapacidadeSistema, RetornaMatrizItem, MatrizItem, AjustarObterMatriz, AjusteMatriz, SalvarMatriz, ListarAvaliacaoMatriz, ListaAvaliacaoMatriz, loading, setLoading, Success, Error, ExcluirMatrizIndividual, ObterCapacidade, CapacidadeObter } = useContext(ApiContext)
    const [sistemaKey, setSistemaKey] = useState("");
    const [avaliacoes, setAvaliacoes] = useState([]);
    const [matrizTimeKey, setMatrizTimeKey] = useState("");
    const { btnCriar, btnVer } = useContext(StyleContext)
    const theme = localStorage.getItem('theme') || 'light'

    const handleChange = (index, value) => {
        const novasAvaliacoes = [...avaliacoes];
        novasAvaliacoes[index].nota = Number(value);
        setAvaliacoes(novasAvaliacoes);
    };

    useEffect(() => {
        RetornaSistemaCapacidade()
        RetornaMatrizItem()
        ObterCapacidade()
    }, [])

    useEffect(() => {
        if (sistemaKey) {
            AjustarObterMatriz(sistemaKey)
                .then(() => {
                    setLoading(false);
                });
        }
    }, [sistemaKey])

    useEffect(() => {
        if (AjusteMatriz && AjusteMatriz.key) {
            setMatrizTimeKey(AjusteMatriz?.key)
        }
    }, [AjusteMatriz])

    useEffect(() => {
        if (matrizTimeKey) {
            ListarAvaliacaoMatriz(matrizTimeKey)
        }
    }, [matrizTimeKey])

    useEffect(() => {
        if (MatrizItem) {
            if (ListaAvaliacaoMatriz && ListaAvaliacaoMatriz.length > 0) {
                setAvaliacoes(
                    MatrizItem.map((item) => {
                        const avaliacaoExistente = ListaAvaliacaoMatriz.find(
                            (a) => a.matrizTimeItem.key === item.key
                        );
                        return {
                            nota: avaliacaoExistente ? avaliacaoExistente.nota : "",
                            matrizTimeItemKey: item.key,
                        };
                    })
                );
            } else {
                setAvaliacoes(
                    MatrizItem.map((item) => ({
                        nota: "",
                        matrizTimeItemKey: item.key,
                    }))
                );
            }
        }
    }, [MatrizItem, ListaAvaliacaoMatriz]);

    const cor = (descricao) => {
        switch (descricao) {
            case 1:
                return "input-red"
            case 2:
                return "input-orange"
            case 3:
                return "input-yellow"
            case 4:
                return "input-lightgreen"
            case 5:
                return "input-green"
            default:
                break;
        }
    }

    const corInput = (descricao) => {
        switch (descricao) {
            case 1:
                return "input-red"
            case 2:
                return "input-orange"
            case 3:
                return "input-yellow"
            case 4:
                return "input-lightgreen"
            case 5:
                return "input-green"
            default:
                break;
        }
    }

    const corColunaPrincipal = (avaliacao) => {
        if (!avaliacao) return "";
        switch (avaliacao.trim()) {
            case "Valor, Aplicação e Aderência Negócio e Processos":
                return "coluna-principal-laranja";
            case "Risco Operacional":
                return "coluna-principal-azul";
            case "Riscos Técnicos":
                return "coluna-principal-verde";
            case "Custos":
                return "coluna-principal-roxo";
            default:
                return "coluna-principal-laranja";
        }
    };

        const corBorda = (avaliacao) => {
        if (!avaliacao) return "";
        switch (avaliacao.trim()) {
            case "Valor, Aplicação e Aderência Negócio e Processos":
                return "#e26b0a";
            case "Risco Operacional":
                return "#0070c0";
            case "Riscos Técnicos":
                return "#31869b";
            case "Custos":
                return "#60497a";
            default:
                return "#e26b0a";
        }
    };

    let avaliacaoAtual = "";

    const corLinhaAvaliacao = (avaliacao) => {
        if (avaliacao && avaliacao.trim() !== "") {
            avaliacaoAtual = avaliacao.trim();
        }

        switch (avaliacaoAtual) {
            case "Valor Aplicação e Aderência Negócio e Processos":
                return "linha-laranja";
            case "Risco Operacional":
                return "linha-azul";
            case "Riscos Técnicos":
                return "linha-verde";
            case "Custos":
                return "linha-roxo";
            default:
                return "";
        }
    };

    const handleClose = () => {
        setAvaliacoes([]);
        setMatrizTimeKey("");
        setModalAvaliar(false);
    };

    const excluir = () => {
        ExcluirMatrizIndividual(matrizTimeKey);
        setSistemaKey("")
        setAvaliacoes([]);
        setMatrizTimeKey("");
    }

    return (
        <>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className="modal-novo">
                <div className="modal-novo-interno-matriz">
                    <div className="header-modal">
                        <h1 className="h1-modal">Matriz de Avaliação</h1>
                        <div className="btn-close-modal" onClick={handleClose}>
                            <FaTimes />
                        </div>
                    </div>
                    <form onSubmit={(e) => SalvarMatriz(e, avaliacoes, matrizTimeKey)}>
                        <div className="modal-content">
                            <div className='mb-3' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '35%' }}>
                                    <Form.Group>
                                        <Form.Label className='mb-0'>Capacidade de Negócio Avaliada</Form.Label>
                                        <p className='span-bsc'>{CapacidadeObter?.nivel ? `${CapacidadeObter.nivel} - ` : ''}{CapacidadeObter?.titulo}</p>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label className='mb-1'>Aplicação</Form.Label>
                                        <Form.Select aria-label="Default select example" onChange={(e) => setSistemaKey(e.target.value)} value={CapacidadeSistema?.key} name="sistemaKey">
                                            <option value="">Selecione</option>
                                            {CapacidadeSistema &&
                                                CapacidadeSistema?.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item.key}>{item.nome}</option>
                                                    )
                                                })

                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div>
                                    <div><div style={{ backgroundColor: '#F87171', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></div> 1 (pior) - Alta taxa de grandes e disruptivas mudanças
                                    </div>
                                    <div><div style={{ backgroundColor: '#ee7605', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></div>2 (abaixo da média) - Capacidade de suporte imprevisível ou inferior a média</div>
                                    <div><div style={{ backgroundColor: '#eebf05', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></div>3 (média) - Disponibilidade média de custo</div>
                                    <div><div style={{ backgroundColor: '#89cf06', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></div>4 (acima da média) - Custos estáveis, gerenciáveis e níveis de serviço</div>
                                    <div><div style={{ backgroundColor: '#16A34A', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></div>5 (melhor) - Sem problemas de execução ou eficiência</div>
                                </div>
                            </div>
                            {sistemaKey ?
                                <div style={{ maxHeight: '500px', overflow: 'auto', marginBottom: '10px' }}>
                                    <div className="div-comentario" style={{ justifyContent: 'end', padding: '0 10px 10px 0' }}>
                                        <p className="p-title" style={{ marginLeft: '5px' }}>Avaliado por:</p>
                                        <span>{AjusteMatriz && AjusteMatriz?.usuarioCriacao?.nome}</span>
                                    </div>
                                    {loading ?
                                        <LoadingScreen />
                                        :
                                        <table className='table-swot'>
                                            <thead style={{ backgroundColor: theme == 'light' ? "#A7A7AB" : '#D4D4D8' }}>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th>Avaliação</th>
                                                    <th>Indicador</th>
                                                    <th></th>
                                                    <th style={{ width: '8%' }}>Nota</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {MatrizItem &&
                                                    MatrizItem.map((item, index) => {
                                                        const avaliacaoAnterior = index > 0 ? MatrizItem[index - 1].avaliacao : null;
                                                        const mostrarAvaliacao = item.avaliacao !== avaliacaoAnterior;

                                                        return (
                                                            <tr key={item.id} className={corLinhaAvaliacao(item.avaliacao)}>
                                                                <td style={{borderBottom: `1px solid ${corBorda(item.avaliacao)}`}} className={`coluna-principal ${corColunaPrincipal(item.avaliacao)}`}>{mostrarAvaliacao ? item.avaliacao : ""}</td>
                                                                <td style={{color: '#000'}}>{item.indicador}</td>
                                                                <td style={{color: '#000'}}>{item.explicacaoItem}</td>
                                                                <td style={{ width: '8%' }}>
                                                                    <Form.Select
                                                                        value={avaliacoes[index]?.nota ?? ""}
                                                                        onChange={(e) => handleChange(index, e.target.value)}
                                                                        id={corInput(avaliacoes[index]?.nota)}
                                                                    >
                                                                        <option value="">0</option>
                                                                        {[1, 2, 3, 4, 5].map((num) => (
                                                                            <option key={num} value={num} className={cor(num)}>
                                                                                {num}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    }
                                    <div>
                                        <button type="button" className='btn-excluir' onClick={excluir}> <TbTrash /> Excluir</button>
                                    </div>
                                </div>
                                :
                                <p>Selecione uma aplicação</p>
                            }
                        </div>
                        <div className="footer-modal-criar-demanda">
                            <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                            <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}